import React, { useEffect, useCallback, useState} from 'react';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';

const TransformationSelector = ({parameter, sequencerEngine}) => { 
    let [value, setValue] = useState(parameter.get());
    let options = sequencerEngine.tracks.map(
        t => t.pattern.stepGroups
            .map(group => group.transformations.map(
                (tr, i) => ({
                    value: tr.id,
                    label: (t.trackNumber + 1) + '.' + group.name + '.tr' + (i + 1)
                })))
            .reduce((a,b) => [...a, ...b], [])
    )
        .reduce((a,b) => [...a, ...b], []);

    const onChange = useCallback((o) => {
        parameter.set(o.value);
        setValue(o.value);
    }, [setValue]);

    return (
        <Dropdown
          options={options}
          value={options.find(x => x.value === parameter.get())}
          onChange={onChange}
          placeholder="Depends"/>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransformationSelector);
